import { separateMoneyNumbers, toFarsiNumber } from "@utils/digits";
import DiscountBadge from "../discout-badge";

import classNames from "classnames";
import AddedCartIcon from "@svg/new-design/added-cart";
import CartIcon from "@svg/new-design/cart";
import LoadingCircleIcon3 from "@svg/new-design/loading-circle-3";
import { FC, useState } from "react";
import CardDivider from "./card-divider";
import { FESTIVAL_TYPE } from "enums/festival-type";
import { useCardAction } from "../useCartAction";

interface Props {
  showShoppingCart: boolean;
  salePrice: number | undefined;
  price: number | undefined;
  discount: number | undefined;
  isPercentDiscount: boolean | undefined;
  id: number;
  sku?: string;
  inCart: boolean | undefined;
  showDivider: boolean;
}

const CommonFooterCard: FC<Props> = ({
  salePrice,
  price,
  discount,
  isPercentDiscount,
  id,
  sku,
  inCart,
  showShoppingCart,
  showDivider,
}) => {
  const { addToCart } = useCardAction();

  const [loading, setIsLoading] = useState(false);
  const [isBuyBasket, setIsBuyBasket] = useState(inCart || false);

  const handleAddToCart = async () => {
    if (!loading) {
      setIsLoading(true);

      try {
        const addToCartResponse = await addToCart?.(id as number, sku || "");
        if (addToCartResponse) setIsBuyBasket(true);
      } catch (error: any) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    }
  };
  return (
    <>
      <CardDivider showDivider={showDivider} />
      <div className="flex justify-between w-full items-center h-fds-34 sm:h-9   -mt-px">
        <div
          className={classNames(
            showShoppingCart ? "flex-col-reverse" : "h-fds-30 items-center",
            "flex justify-between w-full grow "
          )}
        >
          <div className="flex items-center gap-1.5">
            {salePrice && (
              <s className="text-fds-tertiary md:body-md body-xxsm">
                {separateMoneyNumbers(toFarsiNumber(price))}
              </s>
            )}
            <p className="md:title-lg title-md-demibold text-fds-primary">
              {`${
                salePrice
                  ? separateMoneyNumbers(toFarsiNumber(salePrice))
                  : separateMoneyNumbers(toFarsiNumber(price))
              } `}
              <span className="body-xxsm md:body-sm text-fds-secondary">
                تومان
              </span>
            </p>
          </div>

          {!showShoppingCart && (
            <div className="flex gap-1.5  items-center">
              {discount && (
                <DiscountBadge
                  discount={isPercentDiscount ? discount : FESTIVAL_TYPE.WONDER}
                />
              )}
            </div>
          )}
        </div>
        {showShoppingCart && (
          <div
            className={classNames(
              "md:hover:bg-fds-brand-light grow shrink-0 md:h-12 md:w-12 h-10 w-10 flex items-center justify-center transition-all duration-300 ease-in-out bg-transparent rounded-8",
              !isBuyBasket && !loading ? "cursor-default" : "cursor-pointer"
            )}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              if (!loading && !isBuyBasket) handleAddToCart();
            }}
          >
            {isBuyBasket ? (
              <AddedCartIcon className="cursor-default  md:h-6 md:w-6 h-5 w-5" />
            ) : loading ? (
              <LoadingCircleIcon3 className="animate h-6 w-6 animate-spin" />
            ) : (
              <CartIcon className="cursor-pointer md:h-6 md:w-6 h-5 w-5" />
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default CommonFooterCard;
